import { Link } from 'react-router-dom';
import { ModelScene, CreateScene, EntityScene, UpdateScene, DeleteScene, IndexScene } from 'components';
import { Nav } from './Nav';
import { Form } from './Form';
import { OneCIntegration } from './OneCIntegration';
import { Membership } from './Membership';
import { MembershipLog } from './MembershipLog';
import { PlanningConfig } from './PlanningConfig';
import { bool } from 'components/columns';
import type { Enterprise } from 'modules/core/types';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';

import { Branding } from './Branding';
import { BigQueryIntegration } from './BigQueryIntegration';
import { RadioSurveys } from './RadioSurveys';
import { Sequences } from './Sequences';

const columns: ControlledTableColumns<Enterprise> = [
  flexColumn({
    content: 'Company',
    key: 'company',
    required: true,
    render: ({ id, company: { title } }: Enterprise) => <Link to={`${id}`}>{title}</Link>,
  }),
  {
    content: 'Slug',
    key: 'slug',
    width: 140,
  },
  bool('External', 'external'),
];

const initialValues = {
  company: null,
  external: false,
  vat_strategy: 'GROUP_VAT',
  direct_agreements: false,
  plan_naming_sheet: false,
  income_default_hide_issuer: false,
  avb_default_row_title: {},
  accounting_integration_key: null,
  onec: null,
  horizon: null,
};

function mapValues(v: any): any {
  if (v.external) {
    const { company, slug, external } = v;
    return { company, slug, external };
  }
  return v;
}

const model = {
  endpoint: 'core/enterprises/',
  title: 'Agency',
  pluralTitle: 'Agencies',
  entityTitle: ({ company: { title } }: Enterprise) => title,
  permissions: undefined,
};

const entityChildren = [
  {
    index: true,
    element: (
      <UpdateScene heading={null} mapValues={mapValues}>
        <Form />
      </UpdateScene>
    ),
  },
  { path: 'branding', element: <Branding /> },
  { path: 'sequences', element: <Sequences /> },
  { path: 'planning', element: <PlanningConfig /> },
  { path: 'membership/*', element: <Membership /> },
  { path: 'membership_log/', element: <MembershipLog /> },
  { path: 'onec/*', element: <OneCIntegration /> },
  ...(window.__RUNTIME_CONFIG__?.BIGQUERY_ENABLED ? [{ path: 'bigquery', element: <BigQueryIntegration /> }] : []),
  ...(window.__RUNTIME_CONFIG__?.BALTIC_RADIO_SURVEY_ENABLED
    ? [{ path: 'radio-surveys', element: <RadioSurveys /> }]
    : []),
  { path: 'delete', element: <DeleteScene /> },
];

export const route = {
  path: 'agencies',
  element: <ModelScene {...model} />,
  children: [
    { index: true, element: <IndexScene columns={columns} /> },
    {
      path: 'create',
      element: (
        <CreateScene initialValues={initialValues} mapValues={mapValues}>
          <Form />
        </CreateScene>
      ),
    },
    {
      path: ':id/',
      element: (
        <EntityScene>
          <Nav />
        </EntityScene>
      ),
      children: entityChildren,
    },
  ],
};
